(() => {
  const bindSection = (root) => {
    if (!root || root.getAttribute('data-posizioni-bound') === '1') return;

    const select = root.querySelector('[data-posizioni-filter]');
    const pagination = root.querySelector('[data-posizioni-pagination]');
    const cards = Array.from(root.querySelectorAll('[data-provincia]'));
    if (!select || !pagination || cards.length === 0) return;

    root.setAttribute('data-posizioni-bound', '1');

    let activeLocation = 'all';
    let currentPage = 1;
    const pageSize = Number.parseInt(root.dataset.pageSize || '6', 10) || 6;

    const getFilteredCards = () =>
      cards.filter((card) => {
        const cardLocation = (card.getAttribute('data-provincia') || '').trim().toLowerCase();
        return activeLocation === 'all' || cardLocation === activeLocation;
      });

    const createButton = ({ label, page, current = false, disabled = false }) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'posizioni-aperte__pagination-btn';
      button.textContent = label;

      if (current) {
        button.classList.add('is-current');
        button.setAttribute('aria-current', 'page');
      } else if (disabled) {
        button.disabled = true;
        button.classList.add('is-disabled');
      } else {
        button.setAttribute('data-page', String(page));
      }

      return button;
    };

    const renderPagination = (totalPages) => {
      pagination.innerHTML = '';
      if (totalPages <= 1) {
        pagination.classList.add('is-hidden');
        return;
      }

      pagination.classList.remove('is-hidden');

      const list = document.createElement('ul');
      list.className = 'posizioni-aperte__pagination-list';

      const prevItem = document.createElement('li');
      prevItem.appendChild(
        createButton({
          label: '<',
          page: currentPage - 1,
          disabled: currentPage === 1
        })
      );
      list.appendChild(prevItem);

      for (let i = 1; i <= totalPages; i += 1) {
        const pageItem = document.createElement('li');
        pageItem.appendChild(
          createButton({
            label: String(i),
            page: i,
            current: i === currentPage
          })
        );
        list.appendChild(pageItem);
      }

      const nextItem = document.createElement('li');
      nextItem.appendChild(
        createButton({
          label: '>',
          page: currentPage + 1,
          disabled: currentPage === totalPages
        })
      );
      list.appendChild(nextItem);

      pagination.appendChild(list);
    };

    const render = () => {
      const filteredCards = getFilteredCards();
      const totalPages = Math.max(1, Math.ceil(filteredCards.length / pageSize));
      const safePage = Math.min(currentPage, totalPages);
      const startIndex = (safePage - 1) * pageSize;
      const endIndex = startIndex + pageSize;

      cards.forEach((card) => card.classList.add('is-hidden-by-filter'));
      filteredCards.slice(startIndex, endIndex).forEach((card) => card.classList.remove('is-hidden-by-filter'));

      currentPage = safePage;
      renderPagination(totalPages);
    };

    select.addEventListener('change', () => {
      activeLocation = (select.value || 'all').trim().toLowerCase();
      currentPage = 1;
      render();
    });

    pagination.addEventListener('click', (event) => {
      const button = event.target.closest('button[data-page]');
      if (!button) return;
      const nextPage = Number.parseInt(button.getAttribute('data-page') || '', 10);
      if (Number.isNaN(nextPage) || nextPage < 1) return;
      currentPage = nextPage;
      render();
    });

    render();
  };

  const init = () => {
    document.querySelectorAll('[data-posizioni-aperte]').forEach(bindSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const target = event.target;
    if (!target) return;
    if (target.matches?.('[data-posizioni-aperte]')) bindSection(target);
    target.querySelectorAll?.('[data-posizioni-aperte]').forEach(bindSection);
  });
})();
